<div class="row" [class.ng-invalid]="isInvalid()">
    <span class="section-title">
        {{ title }}
        <span class="required-asterisk" *ngIf="isRequired">*</span>
    </span>
    <mat-form-field appearance="outline" class="col-6">
        <mat-label>Start time</mat-label>
        <mat-select [formControl]="startTimeControl">
            <mat-option *ngFor="let time of startTimeOptions" [value]="time.value">
                {{ time.display }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="shouldShowStartTimeError()">
            Start time is required
        </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-6">
        <mat-label>End time</mat-label>
        <mat-select [formControl]="endTimeControl">
            <mat-option *ngFor="let time of endTimeOptions" [value]="time.value">
                {{ time.display }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="shouldShowEndTimeError()">
            End time is required
        </mat-error>
    </mat-form-field>
</div>
